import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import ChoiceMenu from "./ChoiceMenu";
import CustomTextButton from "./CustomTextButton";

import { useTranslation } from "react-i18next";

export default function ChangeChoiceButton({ addHandler, selected, disabled }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedType, setSelectedType] = useState(selected);

  // show menu with more questionTypes
  const handleOpen = () => setOpen(true);

  // close the menu
  const handleClose = () => setOpen(false);

  // click on a qustionType in the menu
  const handleItemClick = (type) => {
    setSelectedType(type);
    addHandler(type);
    handleClose();
  };
  return (
    <Box>
      {/*  <Box pl={3} visibility={selectedType === "likert" ? "visible" : "hidden"}>
        <FormControlLabel
          control={
            <Switch
              checked={allowMultipleChoice}
              onChange={handleAllowMultipleChoice}
              defaultChecked
              size="small"
            />
          }
          label={
            <Typography variant="body2">Allow multiple options</Typography>
          }
        />
      </Box> */}
      <Box textAlign={"right"}>
        <CustomTextButton
          anchorRef={anchorRef}
          title={t(`editor.questionTypes.${selectedType}.title`)}
          handleClick={handleOpen}
          disabled={disabled}
        />
        <ChoiceMenu
          open={open}
          anchorRef={anchorRef}
          placement={"bottom-end"}
          selectedType={selectedType}
          handleClose={handleClose}
          handleItemClick={handleItemClick}
        />
      </Box>
    </Box>
  );
}
